export default "__VITE_ASSET__BS$2RSxc__"